import { render, staticRenderFns } from "./performance.component.vue?vue&type=template&id=475e1a2e&scoped=true"
import script from "./performance.component.vue?vue&type=script&lang=js"
export * from "./performance.component.vue?vue&type=script&lang=js"
import style0 from "./performance.component.vue?vue&type=style&index=0&id=475e1a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e1a2e",
  null
  
)

export default component.exports